import { type FunctionComponent, useMemo, type CSSProperties, useCallback } from 'react';
import { useSelector } from '@/react/core/reactive.ts';
import {activeRoomId, isManual, setActiveRoomId, setIsManual} from '@/react/FloorPlanView/FloorPlanView.tsx';
import { makeRipple } from '@/react/core/ripple-utils.ts';

type ManuelTableFloorButtonType = {
  floorText?: string;
  showSelected?: boolean;
  showRedDot?: boolean;

  /** Style props */
  manuelTableFloorButtonHeight?: CSSProperties["height"];
  manuelTableFloorButtonMinWidth?: CSSProperties["minWidth"];

  _id: string;
};

const ManuelTableFloorButton: FunctionComponent<ManuelTableFloorButtonType> = ({
  floorText = "Main Area",
  showSelected = true,
  showRedDot = true,
  manuelTableFloorButtonHeight,
  manuelTableFloorButtonMinWidth,
  _id
}) => {
  const isSelected = useSelector(activeRoomId);
  const onClick = useCallback(() => {
    setActiveRoomId(_id)
    setIsManual(false)
  }, [_id]);
  showSelected = isSelected(_id) && !isManual()

  const manuelTableFloorButtonStyle: CSSProperties = useMemo(() => {
    return {
      height: manuelTableFloorButtonHeight,
      minWidth: manuelTableFloorButtonMinWidth,
    };
  }, [manuelTableFloorButtonHeight, manuelTableFloorButtonMinWidth]);

  return (
    <div
      className="rounded-10xs bg-steelblue bg-blue-solid-blue-200-51729e flex flex-row items-center justify-center py-[11px] px-2 box-border relative gap-[8px] text-center text-sm text-white font-mulish"
      style={manuelTableFloorButtonStyle}
      onPointerDown={onClick}
      ref={makeRipple}
    >
      {showSelected && (
        <div className="absolute my-0 mx-[!important] h-full w-full top-[0px] right-[0px] bottom-[0px] left-[0px] rounded-10xs bg-orange z-[0]" />
      )}
      <b className="flex-1 relative z-[1] Tablet_600:text-smi Mobile_480:text-xs">
        {floorText}
      </b>
      {showRedDot && (
        <div className="absolute my-0 mx-[!important] top-[4px] right-[4px] rounded-[50%] bg-crimson-200 bg-red-opacity-red-80-e63950 w-2 h-2 z-[2]" />
      )}
    </div>
  );
};

export default ManuelTableFloorButton;
